import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useAuth();

  const storedUser = user || JSON.parse(localStorage.getItem('user'));

  if (!storedUser) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;